import React from 'react';
import {
    Wrapper,
    Content,
    Controls,
    Header,
    InfoGroup,
    FeedbackSubjectStatus,
    Title,
} from './card-feedback-subject.styles';
import { CardFeedbackSubjectProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import dayjs from 'dayjs';
import { EntityRelatedUser } from '@shared/ui/entity-related-user/entity-related-user';

export const CardFeedbackSubject: React.FC<CardFeedbackSubjectProps> = ({ feedbackSubject, children, ...props }) => {
    return (
        <Wrapper {...props}>
            <Header>
                <Title size='subtitle2' color='neutral_90'>
                    {feedbackSubject.title}
                </Title>
                <Controls>{children}</Controls>
            </Header>
            <Content>
                <InfoGroup $maxWidth={192}>
                    <Typography size='body2_long' color='neutral_50'>
                        Системное название (код)
                    </Typography>
                    <Typography size='body2_long'>{feedbackSubject.code}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={106}>
                    <Typography size='body2_long' color='neutral_50'>
                        Сортировка
                    </Typography>
                    <Typography size='body2_long'>{feedbackSubject.sort}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={254}>
                    <Typography size='body2_long' color='neutral_50'>
                        Привязанные администраторы
                    </Typography>
                    <EntityRelatedUser count={String(feedbackSubject.userCount)} />
                </InfoGroup>
                <InfoGroup $maxWidth={114}>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата создания
                    </Typography>
                    <Typography size='body2_long'>
                        {feedbackSubject.createdAt ? dayjs(feedbackSubject.createdAt).format('DD.MM.YY') : '-'}
                    </Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={114}>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата изменения
                    </Typography>
                    <Typography size='body2_long'>
                        {feedbackSubject.updatedAt ? dayjs(feedbackSubject.updatedAt).format('DD.MM.YY') : '-'}
                    </Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={186}>
                    <Typography size='body2_long' color='neutral_50'>
                        Email-администратора
                    </Typography>
                    <Typography size='body2_long'>{feedbackSubject.updatedLogin}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={154}>
                    <Typography size='body2_long' color='neutral_50'>
                        Состояние
                    </Typography>
                    <FeedbackSubjectStatus $active={feedbackSubject.active}>
                        {feedbackSubject.active ? 'Активный' : 'Скрытый'}
                    </FeedbackSubjectStatus>
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
